module.exports = __webpack_public_path__ + "resources/images/zorgtoeslag-de6034512d19c8a81415115eb8ea93be-cache.jpg";